// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const brambleghast: PokeData = {
  "id": 947,
  "name": "brambleghast",
  "height": 12,
  "weight": 60,
  "base_experience": 168,
  "types": [
    PokeType.GRASS,
    PokeType.GHOST
  ],
  "api_moves": [
    "disable",
    "absorb",
    "mega-drain",
    "defense-curl",
    "curse",
    "giga-drain",
    "rollout",
    "pain-split",
    "rapid-spin",
    "astonish",
    "bullet-seed",
    "power-whip",
    "hex",
    "phantom-force",
    "infestation"
  ],
  "moves": [
    "curse",
    "bullet-seed",
    "power-whip",
    "phantom-force",
    "spectral-chain",
    "leaf-tornado",
    "poltergeist",
    "razor-leaf",
    "shadow-sneak",
    "frenzy-plant",
    "shadow-claws",
    "aromatherapy",
    "shadow-ball"
  ],
  "evolution_chain": {
    "id": 495,
    "item": null,
    "species": [
      {
        "name": "bramblin",
        "order": 974,
        "types": [
          PokeType.GRASS,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "brambleghast",
        "order": 975,
        "types": [
          PokeType.GRASS,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 946,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 93,
    "speed": 135,
    "ability_power": 172
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
